import React from 'react'
import { useSelector } from 'react-redux'

import { AppState } from 'common/store'
import {
    StyledActionLinks,
    StyledActionButton,
    subscribeButtonClassname,
    StyledPremiumIcon,
    StyledSkeleton,
} from './TheWestHeaderLogin.styled'
import { RegionalActionLink } from './RegionalActionLink'
import { UserNameLink } from './UserNameLink'
import { LogoutActionLink } from './LogoutActionLink'
import { useTheme } from '@emotion/react'
import { createSubscribeLinkClickEvent } from 'component-library/user-registration/subscribe/createSubscribeClickLinkHandler'

export interface AuthSiteLoginActionLinksProps {
    onSubscribeClick: () => void
    onLogoutClick: () => void
    onLoginClick: () => void
    onEvent: (event: any) => void
}

export const AuthSiteLoginActionLinks: React.FC<AuthSiteLoginActionLinksProps> = ({
    onSubscribeClick,
    onLogoutClick,
    onLoginClick,
    onEvent,
}) => {
    const authState = useSelector((state: AppState) => state.authentication)
    const { section } = useTheme()
    const isRegionalSite = section !== 'default'

    return authState.isLoggedIn ? (
        <ActionLinksAuthenticated
            isRegionalSite={isRegionalSite}
            onLogoutClick={onLogoutClick}
            userName={authState.userName}
        />
    ) : (
        <ActionLinksUnauthenticated
            isRegionalSite={isRegionalSite}
            onSubscribeClick={onSubscribeClick}
            onLoginClick={onLoginClick}
            hasAttemptedValidation={authState.hasAttemptedValidation}
            onEvent={onEvent}
        />
    )
}

export interface ActionLinksUnauthenticatedProps {
    isRegionalSite: boolean
    onLoginClick: () => void
    onSubscribeClick: () => void
    hasAttemptedValidation: boolean
    onEvent: (event: any) => void
}

export const ActionLinksUnauthenticated: React.FC<ActionLinksUnauthenticatedProps> = ({
    isRegionalSite,
    hasAttemptedValidation,
    onLoginClick,
    onSubscribeClick,
    onEvent,
}) => (
    <StyledActionLinks>
        {isRegionalSite && <RegionalActionLink />}

        <StyledActionButton isPrimary={false} onClick={onLoginClick}>
            {hasAttemptedValidation ? 'Login' : <StyledSkeleton count={1} />}
        </StyledActionButton>

        <StyledActionButton
            className={subscribeButtonClassname}
            onClick={() => {
                createSubscribeLinkClickEvent('header', onEvent)()
                onSubscribeClick()
            }}
            isPrimary={true}
        >
            {hasAttemptedValidation ? (
                <React.Fragment>
                    <StyledPremiumIcon />
                    Subscribe
                </React.Fragment>
            ) : (
                <StyledSkeleton count={1} />
            )}
        </StyledActionButton>
    </StyledActionLinks>
)

export interface ActionLinksAuthenticatedProps {
    isRegionalSite: boolean
    userName: string
    onLogoutClick: () => void
}

export const ActionLinksAuthenticated: React.FC<ActionLinksAuthenticatedProps> = ({
    isRegionalSite,
    userName,
    onLogoutClick,
}) => (
    <StyledActionLinks>
        {isRegionalSite && <RegionalActionLink />}
        <UserNameLink userName={userName} />
        <LogoutActionLink onLogoutClick={onLogoutClick} />
    </StyledActionLinks>
)
